export default __webpack_public_path__ + "static/media/flag-latvia.f226d7ac.svg";